import { AlmeState } from "@alme/ui-web/wireup/AlmeState";
import { Store } from "redux";
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import { AlightStateType } from "../../types/alight-state";
import {isDesktop, checkCounterAreaVisibility} from '../lib-alight-library/lib-alight-library'

export default class IVAFullScreenMutator {
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlightStateType>) {
        this._store = store;
    }
    
    checkCounterVisibility()
    {
        const language = this._store?.getState().Conversation.Language;
        checkCounterAreaVisibility(language, this._store?.getState(), this._settings)
    }

    IVAWithFullScreen()
    {
        const textCountClass = this._settings.classNames.inputboxCharacterCounter;
        const textCountArea = document.getElementsByClassName(textCountClass)[0] as HTMLElement;
        const conversationElement = document.getElementsByClassName(this._settings.classNames.conversationAreaClassName);
        const ivaWindow = <HTMLElement> document.getElementsByClassName('alme--window ui-draggable')[0];
        const checkCounterVisibility = this.checkCounterVisibility.bind(this);
        const resetHeaderAndCounterVisibility = this.resetHeaderAndCounterVisibility.bind(this);
        if(ivaWindow?.offsetTop == 0)
        {
            if (conversationElement.length > 0) {
                let headerElement = <HTMLElement>document.getElementsByClassName("alme--window--header ui-draggable-handle")[0];
                if(conversationElement[0].scrollTop == 0)
                {
                    headerElement.style.display = "block";
                }
                let prevScrollpos = conversationElement[0].scrollTop;
                document.addEventListener('keydown', function (e) {
                    if (e.key == "ArrowDown" || e.key == "ArrowUp") {
                        resetHeaderAndCounterVisibility(checkCounterVisibility, textCountArea, prevScrollpos);
                    }
                });

                conversationElement[0].addEventListener("scrollend", (event) => {
                    resetHeaderAndCounterVisibility(checkCounterVisibility, textCountArea, prevScrollpos);
                });
            }
        }
        else
        {
            let headerElement = <HTMLElement>document.getElementsByClassName("alme--window--header ui-draggable-handle")[0];
            if (headerElement) {
                headerElement.style.display = "block";
                checkCounterVisibility();
            }
        }
    }

    resetHeaderAndCounterVisibility(checkCounterVisibility: any, textCountArea: HTMLElement, prevScrollpos: number)
    {
        const conversationElement = document.getElementsByClassName(this._settings.classNames.conversationAreaClassName);
        const ivaWindow = <HTMLElement>document.getElementsByClassName('alme--window ui-draggable')[0];
        let headerElement = <HTMLElement>document.getElementsByClassName("alme--window--header ui-draggable-handle")[0];
        var currentScrollPos = conversationElement[0].scrollTop;
        if (ivaWindow?.offsetTop == 0) {
            if (prevScrollpos > currentScrollPos) {
                headerElement.style.display = "block";
                checkCounterVisibility();
            } else {
                headerElement.style.display = "none";
                textCountArea.style.display = "none";
            }
        }
        prevScrollpos = currentScrollPos;
    }

    getMutator(){
        return (parameters = {}) => {
            if (isDesktop(this._store?.getState(), this._settings)) {
                this.IVAWithFullScreen()
            }
            return parameters;
        };
    }
}


// WEBPACK FOOTER //
// ./modules/mutators/ivaFullScreenMutator.ts